<div class="bar-chart">
    <div class="chartdiv" #chart [ngStyle]="{'height': height, 'border' : isBorder ? '1px solid var(--color-border-secondary)' : 'none'}"></div>
    <div id="legend"></div>
</div>
